export interface SpiegazioneErrore {
  readonly titolo: string
  readonly comeRisolvere: string
  readonly testoOriginale: string
  readonly ritentabile: false
}

const RETTIFICA = 'Corretta la dichiarazione, usa «Rettifica» e ripeti firma e invio.'
const RESPINTA = 'Le Dogane hanno acquisito il file ma l hanno respinto nei controlli sostanziali. '
const MONET =
  'Monet (Area Riservata ADM › Servizi online › Interattivi), cercando lo IUT dell invio. ' + RETTIFICA

const NOTI: Record<string, { titolo: string; comeRisolvere: string }> = {
  '197': { titolo: 'Dichiarazione respinta dalle Dogane', comeRisolvere: RESPINTA + 'Il dettaglio si consulta su ' + MONET },
  '198': {
    titolo: 'Dichiarazione respinta dalle Dogane',
    comeRisolvere:
      RESPINTA +
      'I motivi sono nel file di esito: si scarica con «Esito» dallo storico degli invii appena recuperato, ' +
      'oppure da ' +
      MONET,
  },
  '18': {
    titolo: 'Firmatario non autorizzato',
    comeRisolvere:
      'Chi ha firmato il file non risulta abilitato come Sottoscrittore presso le Dogane. ' +
      'Verifica la nomina a Sottoscrittore e che l autorizzazione «Dichiarazione di Energia Elettrica SOTTOSCRITTORE» sia attiva.',
  },
  '14': {
    titolo: 'Utente non autorizzato',
    comeRisolvere:
      'L utenza che trasmette non ha la delega all invio per questa ditta. ' +
      'Verifica la delega e che sia riferita al codice ditta corretto.',
  },
}

/** Per un codice non noto si mostra il testo delle Dogane, senza inventare una diagnosi. */
export function spiegaErroreAdm(codice: string, descrizione: string): SpiegazioneErrore {
  const noto = NOTI[codice]
  return {
    titolo: noto?.titolo ?? `Errore ${codice} restituito dalle Dogane`,
    comeRisolvere: noto?.comeRisolvere ?? '',
    testoOriginale: descrizione,
    ritentabile: false,
  }
}
